import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

import { RegionDropdownComponentConfigurator } from './region-dropdown-component.configurator';
import { BaseMultiselectDropdownComponent } from '@pl/pl-lib/forms';
import { Region } from 'src/app/core/models/region';

@Component({
  selector: 'app-region-multiselect-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/multiselect-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/multiselect-dropdown.component.scss'
  ]
})
export class RegionMultiselectDropdownComponent extends BaseMultiselectDropdownComponent<Region> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new RegionDropdownComponentConfigurator();
  }
}
